module.exports = __webpack_public_path__ + "img/Zimbabwe.3be5d2af.svg";